"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1289],{

/***/ 10121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ chat_ChatEnterPad; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-b8844a88ad/0/cache/chatie-design-system-https-b493a1675a-e8ede12d88.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(91864);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-b8844a88ad/0/cache/chatie-design-system-https-b493a1675a-e8ede12d88.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(76366);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
// EXTERNAL MODULE: ./components/common/RoundAvatar.tsx
var RoundAvatar = __webpack_require__(81794);
// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
;// CONCATENATED MODULE: ./public/icons/ic_play_white.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcPlayWhite = function SvgIcPlayWhite(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M9.916 5.265 2.9.972a.78.78 0 0 0-1.185.658v8.585a.776.776 0 0 0 1.187.659L9.916 6.58a.77.77 0 0 0 0-1.315v-.001m-7.422 4.941v-8.57l7.005 4.287-7.005 4.283"
  })));
};
/* harmony default export */ var ic_play_white = (SvgIcPlayWhite);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/chat.ts
var chat = __webpack_require__(42127);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
;// CONCATENATED MODULE: ./components/chat/ChatEnterPad.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n\n    .name-container {\n      ",
        ";\n      display: flex;\n      align-items: center;\n      ",
        "\n      color:",
        ";\n    }\n    span {\n      white-space: nowrap;\n    }\n    .name {\n      white-space: wrap;\n      ",
        ";\n      margin-left: ",
        "px;\n    }\n\n    .play-count {\n      display: flex !important;\n      white-space: wrap;\n      margin-top: ",
        "px;\n      ",
        ";\n      ",
        ";\n      align-items: center;\n      margin-left: ",
        "px;\n      gap: 2px;\n    }\n\n    .enter-button {\n      display: flex;\n      margin-left: ",
        "px;\n      align-items: center;\n      gap: ",
        "px;\n      ",
        "\n      color:",
        "\n    }\n\n    .enter-text-container {\n      display: flex;\n      flex-direction: column;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 16px;\n  width: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var GRADATION_MAIN_COLOR_OPACITY_60 = " #20aeae99";
var wrapperCSS = function(background) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject(), background ? background : "linear-gradient(\n      90deg,\n      ".concat(theme.colors.main500, " 0%,\n      ").concat(GRADATION_MAIN_COLOR_OPACITY_60, " 100%\n    )"));
    };
};
var containerCSS = function(isPeek) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject1(), isPeek ? "height: 30px" : "", dist_esm/* Typography.body14 */.ZT.body14, theme.var.white, (0,css/* multilineEllipsis */.Zy)(1), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, (0,css/* multilineEllipsis */.Zy)(1), dist_esm/* Typography.body11 */.ZT.body11, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body12 */.ZT.body12, theme.var.white);
    };
};
var badgeCSS = (0,emotion_react_browser_esm.css)(_templateObject2());
var ChatEnterPad = function(param) {
    var character = param.character, onClickChatEnter = param.onClickChatEnter, _enterText = param.enterText, enterText = _enterText === void 0 ? "입장" : _enterText, wrapperCss = param.wrapperCss, isNew = param.isNew, playCount = param.playCount, _onlyName = param.onlyName, onlyName = _onlyName === void 0 ? false : _onlyName, title = param.title, _isPeek = param.isPeek, isPeek = _isPeek === void 0 ? false : _isPeek, background = param.background;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,Badge/* useBadgePresets */.fw)(), newbadge = ref.new;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: [
            wrapperCSS(background),
            wrapperCss
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
            onClick: function(e) {
                if (onClickChatEnter) {
                    e.stopPropagation();
                    onClickChatEnter(character);
                }
            },
            className: "chat-enter-pad",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: containerCSS(isPeek),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "name-container",
                        children: [
                            !isPeek && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RoundAvatar/* default */.Z, {
                                size: 30,
                                picture: character.profile_image
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "enter-text-container",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: "name-container",
                                        children: [
                                            !isPeek && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                className: "name",
                                                children: t("{{characterName}}", {
                                                    characterName: character.name
                                                })
                                            }),
                                            !onlyName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                                children: title ? title : t("".concat((0,misc/* getJosaOnly */.RL)(character.name, "과"), " 대화하기"))
                                            })
                                        ]
                                    }),
                                    (!!playCount || playCount === 0) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: "play-count",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                icon: ic_play_white,
                                                colorPropety: "white"
                                            }),
                                            (0,chat/* formatNumberMillion */.OQ)(playCount)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
                        className: "enter-button",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: t("".concat(enterText))
                            }),
                            isNew && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _objectSpreadProps(_objectSpread({
                                text: t("N")
                            }, newbadge), {
                                css: badgeCSS
                            })),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* ArrowRight */.ol,
                                size: dist_esm/* Sizes.small */.u8.small,
                                color: theme.var.white
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var chat_ChatEnterPad = (ChatEnterPad);


/***/ }),

/***/ 1289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71618);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91864);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76366);
/* harmony import */ var _components_chat_ChatEnterPad__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10121);
/* harmony import */ var _components_common_ActionSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83898);
/* harmony import */ var _components_common_SwipableListContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95728);
/* harmony import */ var _components_modal_CharacterTagSelectionModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26538);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30259);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97033);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81946);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35493);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45874);
/* harmony import */ var _common_Avatar__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81649);
/* harmony import */ var _common_EFinderImage__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11247);
/* harmony import */ var _user_Nickname__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87682);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-left: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: ",
        "px;\n\n    .profile {\n      display: flex;\n      align-items: center;\n    }\n\n    .maker-badge {\n      padding: 0 4px;\n      display: flex;\n      align-items: center;\n      height: 18px;\n      border: 1px solid ",
        ";\n      border-radius: ",
        "px;\n\n      ",
        ";\n      font-weight: 600;\n      line-height: 14.85px;\n      color: ",
        ";\n    }\n\n    .nickname {\n      margin-left: ",
        "px;\n\n      .fixedContainer {\n        display: flex;\n        align-items: center;\n        gap: ",
        "px;\n      }\n\n      small {\n        display: block;\n        margin-top: ",
        "px;\n        color: ",
        ";\n        ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:before {\n    content: '\\00a0';\n  }\n"
    ], [
        "\n  color: ",
        ";\n\n  &:before {\n    content: '\\\\00a0';\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n            & > span {\n              position: unset !important;\n              & > img {\n                position: unset !important;\n                height: auto !important;\n                object-fit: contain !important;\n              }\n            }\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n            padding-bottom: 60%;\n          "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: ",
        "px;\n      position: relative;\n      ",
        ";\n      background-color: ",
        ";\n      border-radius: 9px;\n\n      ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  color: ",
        ";\n\n  button {\n    ",
        ";\n  }\n\n  button + button {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: ",
        "px;\n  margin-top: 4px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: ",
        "px;\n  margin-bottom: ",
        "px;\n  margin-top: 14px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n  gap: ",
        "px;\n  line-height: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n\n  .user-name {\n    ",
        ";\n  }\n\n  .content {\n    ",
        ";\n    color: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




















var postCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject());
var postFixedCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, theme.var.gray600, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xhsmall */ .Ki.xhsmall);
};
var postUserCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, theme.colors.main500, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.xsmall */ .wU.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body11 */ .ZT.body11, theme.colors.main500, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xxsmall */ .Ki.xxsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xxsmall */ .Ki.xxsmall, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12);
};
var postContentCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body14 */ .ZT.body14);
var postContentMoreBtnCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject4(), theme.var.gray500);
};
var postPictureCSS = function(isClip, imageHeight) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, imageHeight ? "height: ".concat(imageHeight, "px") : "", theme.var.gray400, !isClip ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject5()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject6()));
    };
};
var postButtonCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject8(), theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall);
};
var tagCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject9(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall);
var ctaCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject10(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.small */ .wU.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall);
var commentPreviewCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject11(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.h6 */ .ZT.h6, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body14 */ .ZT.body14, theme.var.gray500);
};
var CharacterPost = function(_param) {
    var playerId = _param.playerId, tmp = _param.clip, isClip = tmp === void 0 ? false : tmp, onLike = _param.onLike, handleActionSheet = _param.handleActionSheet, handleClickTag = _param.handleClickTag, playButton = _param.playButton, tags = _param.tags, character = _param.character, handleClickPlay = _param.handleClickPlay, commentPreview = _param.commentPreview, handleClickImg = _param.handleClickImg, _hasFixedAction = _param.hasFixedAction, hasFixedAction = _hasFixedAction === void 0 ? true : _hasFixedAction, imageHeight = _param.imageHeight, _showFixedIcon = _param.showFixedIcon, showFixedIcon = _showFixedIcon === void 0 ? true : _showFixedIcon, _post = _objectWithoutProperties(_param, [
        "playerId",
        "clip",
        "onLike",
        "handleActionSheet",
        "handleClickTag",
        "playButton",
        "tags",
        "character",
        "handleClickPlay",
        "commentPreview",
        "handleClickImg",
        "hasFixedAction",
        "imageHeight",
        "showFixedIcon"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__.u)();
    var ref5 = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_11__/* .useMe */ .Pi)(), me = ref5.data;
    var post = _post;
    var id = post.id, user = post.user, content = post.content, picture = post.picture, likeCount = post.likeCount, commentCount = post.commentCount, isFixed = post.isFixed, isLiked = post.isLiked, isUpdated = post.isUpdated, created = post.created;
    var isMaker = playerId === (user === null || user === void 0 ? void 0 : user.id);
    var isMyCharacter = playerId === (me === null || me === void 0 ? void 0 : me.id);
    var isMyPost = (me === null || me === void 0 ? void 0 : me.id) === (user === null || user === void 0 ? void 0 : user.id);
    var tagHeight = 28;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_10__/* .useGlobalContext */ .bN)().platform;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_12__/* .useWebView */ .B9)().web;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var isContain = (picture === null || picture === void 0 ? void 0 : (ref = picture.attachment) === null || ref === void 0 ? void 0 : ref.width) && (picture === null || picture === void 0 ? void 0 : (ref1 = picture.attachment) === null || ref1 === void 0 ? void 0 : ref1.height) && (picture === null || picture === void 0 ? void 0 : (ref2 = picture.attachment) === null || ref2 === void 0 ? void 0 : ref2.width) > (picture === null || picture === void 0 ? void 0 : (ref3 = picture.attachment) === null || ref3 === void 0 ? void 0 : ref3.height);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isContentOpen = ref6[0], setContentOpen = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .trimStringByLine */ .z_)(content, picture && (picture === null || picture === void 0 ? void 0 : picture.key) ? 2 : 5);
    }, [
        content,
        picture
    ]), content1 = ref7[0], content2 = ref7[1];
    var actions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (!me) {
            return [];
        }
        if (isMyPost) {
            return _toConsumableArray(isMyCharacter && hasFixedAction ? [
                isFixed ? {
                    label: t("고정 해제하기"),
                    value: "unfix"
                } : {
                    label: t("고정하기"),
                    value: "fix"
                }, 
            ] : []).concat([
                {
                    label: t("수정하기"),
                    value: "modify"
                },
                {
                    label: t("삭제하기"),
                    value: "delete",
                    isDanger: true
                }, 
            ]);
        } else {
            return _toConsumableArray(isMyCharacter && hasFixedAction ? [
                isFixed ? {
                    label: t("고정 해제하기"),
                    value: "unfix"
                } : {
                    label: t("고정하기"),
                    value: "fix"
                }, 
            ] : []).concat([
                {
                    label: t("신고하기"),
                    value: "report",
                    isDanger: true
                }, 
            ]);
        }
    }, [
        isFixed,
        isMyCharacter,
        isMyPost,
        me,
        t
    ]);
    var handleClickUserProfile = function(e) {
        e.stopPropagation();
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_9__/* .Platform.web */ .t4.web) {
            router.push("/users/".concat(user === null || user === void 0 ? void 0 : user.id, "?tab=play"));
        } else {
            web.openPage("/users/".concat(user === null || user === void 0 ? void 0 : user.id, "?tab=play"));
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("article", {
        css: postCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                css: postUserCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                        className: "profile",
                        onClick: handleClickUserProfile,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_common_Avatar__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, _objectSpread({
                                size: _common_Avatar__WEBPACK_IMPORTED_MODULE_15__/* .AvatarSize.medium */ .DZ.medium
                            }, user)),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                className: "nickname",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                        className: "fixedContainer",
                                        children: [
                                            isMaker && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                                className: "maker-badge",
                                                children: "메이커"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_user_Nickname__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, _objectSpread({}, user))
                                            }),
                                            isFixed && showFixedIcon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("p", {
                                                css: postFixedCSS,
                                                className: "icon-text",
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .PinFill */ .Ft,
                                                        size: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Sizes.small */ .u8.small,
                                                        color: theme.var.gray600
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                                                        children: t("고정됨")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("small", {
                                        children: [
                                            created ? (0,_utils_date__WEBPACK_IMPORTED_MODULE_13__/* .formatDate */ .p6)(created) : "",
                                            isUpdated && " 수정됨"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    handleActionSheet && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_components_common_ActionSheet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        name: "post-card-action-".concat(post.id),
                        options: actions,
                        onSelect: function(value) {
                            return handleActionSheet(value, id);
                        },
                        children: function(open) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("button", {
                                className: "icon-btn",
                                onClick: open,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .VerticalEllipsis */ .oR,
                                    color: theme.var.gray400,
                                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Sizes.small */ .u8.small
                                })
                            });
                        }
                    })
                ]
            }),
            content && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
                children: isClip ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("p", {
                    css: postContentCSS,
                    className: "multiline",
                    children: [
                        content1,
                        !isContentOpen && content2 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("button", {
                            css: postContentMoreBtnCSS,
                            className: "text-btn",
                            onClick: function(e) {
                                e.stopPropagation();
                                setContentOpen(true);
                            },
                            children: [
                                "...",
                                t("더보기")
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("br", {}),
                        isContentOpen && content2,
                        isContentOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("button", {
                            css: postContentMoreBtnCSS,
                            className: "text-btn",
                            onClick: function(e) {
                                e.stopPropagation();
                                setContentOpen(false);
                            },
                            children: t("접기")
                        })
                    ]
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                    css: postContentCSS,
                    className: "multiline",
                    children: content
                })
            }),
            picture && picture.key && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                css: postPictureCSS(isClip, imageHeight),
                onClick: function(e) {
                    if (handleClickImg) {
                        e.stopPropagation();
                        e.preventDefault();
                        handleClickImg(picture);
                    }
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_common_EFinderImage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                    image: picture,
                    radius: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.medium */ .wU.medium,
                    objectFit: isContain ? "contain" : "cover",
                    objectPosition: "center"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                css: postButtonCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("button", {
                        className: "text-btn icon-text",
                        onClick: function(e) {
                            e.stopPropagation();
                            onLike === null || onLike === void 0 ? void 0 : onLike(post);
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: isLiked ? chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .HeartFill */ .Ic : chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Heart */ .YK,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Sizes.small */ .u8.small,
                                color: isLiked ? theme.colors.red500 : theme.var.gray500
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                                children: likeCount || t("좋아요")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("button", {
                        className: "text-btn icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Comment */ .sv,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Sizes.small */ .u8.small,
                                color: theme.var.gray500
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                                children: commentCount || t("댓글달기")
                            })
                        ]
                    })
                ]
            }),
            !!(commentPreview === null || commentPreview === void 0 ? void 0 : commentPreview.length) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                    css: commentPreviewCSS,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                            className: "user-name",
                            children: commentPreview[0].user.nickname
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                            className: "content",
                            children: commentPreview[0].content
                        })
                    ]
                })
            }),
            !!(tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_components_common_SwipableListContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: tags === null || tags === void 0 ? void 0 : tags.map(function(item, index) {
                    var handleClick = function(e) {
                        e.stopPropagation();
                        if (handleClickTag) {
                            handleClickTag(item.id, item.name);
                        }
                    };
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                        css: tagCSS,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_components_modal_CharacterTagSelectionModal__WEBPACK_IMPORTED_MODULE_8__/* .CharacterTag */ ._P, {
                            name: item.name,
                            height: tagHeight,
                            onClick: handleClick
                        }, "tag_".concat(index))
                    });
                })
            }),
            playButton && character && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_components_chat_ChatEnterPad__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                onlyName: true,
                onClickChatEnter: handleClickPlay,
                enterText: "놀러가기",
                wrapperCss: ctaCSS,
                playCount: character === null || character === void 0 ? void 0 : (ref4 = character.stat) === null || ref4 === void 0 ? void 0 : ref4.message_count,
                character: character
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CharacterPost);


/***/ })

}]);